/**
 * @file Writes when the answers on screen were computed, relative to `now`:
 * `"today 04:02"`, `"yesterday 23:10"`, otherwise a date such as
 * `"Aug 4, 2026 04:02"`, always in 24-hour time, and `"recomputing…"` while a
 * recompute runs. Consumer: `AnalyticsLastComputedText`. The build instant
 * is read in the zone of `now`, so the caller picks the zone by passing
 * `DateTime.local()`.
 */
import { DateTime } from 'luxon';

const LOCALE = 'en-US';
const TIME = 'HH:mm';

export const analyticsRelativeComputedText = ({
  builtAt,
  now,
  recomputing,
}: {
  builtAt: string;
  now: DateTime;
  recomputing: boolean;
}): string => {
  if (recomputing) return 'recomputing…';
  const built = DateTime.fromISO(builtAt, { zone: now.zone, locale: LOCALE });
  if (built.hasSame(now, 'day')) return `today ${built.toFormat(TIME)}`;
  if (built.hasSame(now.minus({ days: 1 }), 'day'))
    return `yesterday ${built.toFormat(TIME)}`;
  return built.toFormat(`LLL d, yyyy ${TIME}`);
};
